import { css } from 'styled-components';

// hack for intellisense not working otherwise
const styled = { css };

export const error = styled.css`
  background-color: var(--error);
  color: var(--white);
  -webkit-font-smoothing: initial;
`;

export const warn = styled.css`
  background-color: var(--warn);
  color: var(--warnContent);
  -webkit-font-smoothing: initial;
`;

export const tip = styled.css`
  background-color: var(--tip);
  color: var(--tipContent);
  -webkit-font-smoothing: initial;
`;

export const success = styled.css`
  background-color: var(--success);
  color: var(--successContent);
  color: var(--black0);
`;

export const info = styled.css`
  background-color: var(--info);
  color: var(--infoContent);
  -webkit-font-smoothing: initial;
`;

export const primary = styled.css`
  background-color: var(--main);
  color: var(--white);
`;

export const secondary = styled.css`
  background-color: transparent;
  color: var(--white);
  border: 1px solid rgba(220, 220, 220);
`;

export const light = styled.css`
  background-color: var(--light);
  color: var(--lightContent);
`;
